<template>
<label
    class="checkbox-side"
    :class="{'checkbox-side--checked': modelValue}"
>
    <checkboxIcon class="icon" />
    <input
        class="hidden"
        type="checkbox"
        v-model="modelValue"
        @change="select"
    >
</label>
</template>

<script>
import checkboxIcon from "@/assets/icons/sc-journey/checkbox.svg";

export default {
    name: 'CheckboxSide',
    props: {
        value: {
            type: Boolean,
            required: true,
        }
    },
    components: {
        checkboxIcon,
    },
    data() {
        return {
            modelValue: false,
        }
    },
    computed: {
        // modelValue: {
        //     get() {
        //         return this.value;
        //     },
        //     set(value) {
        //         this.$emit('change', value);
        //     }
        // }
    },
    created() {
        this.modelValue = this.value;
    },
    methods: {
        select(e) {
            this.$emit('change', e);
            
        }
    },
}
</script>

<style lang="scss" scoped>
.checkbox-side {
    box-sizing: border-box;
    border-radius: 8px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 30px;
    border-radius: 0;
    padding: 7px;
    background-color: #C6C6C6;
    .icon {
        width: 100%;
        height: 100%;
        fill: #ADA9A9;
    }
    &--checked {
        background-color: #0D69D5;
        .icon {
            fill: #fff;
        }
    }
}
</style>